export const getFullName = (firstName, lastName) => {
    return [firstName, lastName].filter(Boolean).join(' ');
};
const getLocalization = (speaker, locale) => {
    return locale != null && locale in speaker.localizations
        ? speaker.localizations[locale]
        : speaker.localizations[speaker.neutralData.defaultLocalisation];
};
export const getDefaultSpeakerName = (speaker) => {
    const localization = getLocalization(speaker);
    const variant = localization.nameVariants[localization.defaultVariantIndex];
    return getFullName(variant.firstName, variant.lastName);
};
export const getRoleOptions = (speaker, locale, firstName, lastName) => {
    if (speaker === null) {
        return [];
    }
    const localization = getLocalization(speaker, locale);
    const variant = localization.nameVariants.find((v) => v.firstName === firstName && v.lastName === lastName);
    if (variant === undefined) {
        return [];
    }
    return variant.roles.map((role, index) => ({
        label: role,
        isDefault: index === variant.defaultRoleIndex,
    }));
};
export const getNameVariantOptions = (speaker, locale) => {
    if (speaker === null) {
        return [];
    }
    const localization = getLocalization(speaker, locale);
    return localization.nameVariants.map((variant, index) => ({
        label: getFullName(variant.firstName, variant.lastName),
        isDefault: index === localization.defaultVariantIndex,
        values: {
            firstName: variant.firstName,
            lastName: variant.lastName,
        },
    }));
};
export const isVariantMatch = (variantPaths, locale, variantIndex) => {
    var _a;
    const prefix = `Localizations.${locale}.NameVariants[${variantIndex}]`;
    return (_a = variantPaths === null || variantPaths === void 0 ? void 0 : variantPaths.some((p) => p.startsWith(prefix))) !== null && _a !== void 0 ? _a : false;
};
export const isRoleMatch = (variantPaths, locale, variantIndex, roleIndex) => {
    var _a;
    const prefix = `Localizations.${locale}.NameVariants[${variantIndex}].Roles[${roleIndex}]`;
    return (_a = variantPaths === null || variantPaths === void 0 ? void 0 : variantPaths.some((p) => p.startsWith(prefix))) !== null && _a !== void 0 ? _a : false;
};
const toNameVariant = (item) => {
    var _a, _b, _c, _d;
    return ({
        firstName: (_b = (_a = item.values) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : '',
        lastName: (_d = (_c = item.values) === null || _c === void 0 ? void 0 : _c.lastName) !== null && _d !== void 0 ? _d : '',
        roles: [],
        defaultRoleIndex: -1,
    });
};
const updateLocalization = (dbSpeaker, langCode, overrides) => (Object.assign(Object.assign({}, dbSpeaker), { localizations: Object.assign(Object.assign({}, dbSpeaker.localizations), { [langCode]: Object.assign(Object.assign({}, dbSpeaker.localizations[langCode]), overrides) }) }));
export const buildSpeakerWithUpdatedVariantsAndRoles = (dbSpeaker, langCode, nameVariantEntries, speakerIdActive) => {
    const nameVariants = nameVariantEntries.map((entry) => {
        var _a, _b, _c, _d;
        const firstName = (_b = (_a = entry.nameVariant.values) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : '';
        const lastName = (_d = (_c = entry.nameVariant.values) === null || _c === void 0 ? void 0 : _c.lastName) !== null && _d !== void 0 ? _d : '';
        const { roles } = entry;
        return {
            firstName,
            lastName,
            roles: roles.map((r) => r.label),
            defaultRoleIndex: roles.findIndex((r) => r.isDefault),
        };
    });
    const defaultVariantIndex = nameVariantEntries.findIndex((e) => e.nameVariant.isDefault);
    const updatedSpeakerIdActive = speakerIdActive !== null && speakerIdActive !== void 0 ? speakerIdActive : getLocalization(dbSpeaker, langCode).speakerIdActive;
    return updateLocalization(dbSpeaker, langCode, {
        nameVariants,
        defaultVariantIndex: defaultVariantIndex >= 0 ? defaultVariantIndex : 0,
        speakerIdActive: updatedSpeakerIdActive,
    });
};
const updateVariants = (dbSpeaker, langCode, nameVariants) => updateLocalization(dbSpeaker, langCode, { nameVariants });
export const buildSpeakerWithAddedVariant = (dbSpeaker, langCode, item) => {
    const existing = dbSpeaker.localizations[langCode].nameVariants;
    const newVariant = toNameVariant(item);
    const nameVariants = item.isDefault
        ? [newVariant, ...existing]
        : [...existing, newVariant];
    return updateVariants(dbSpeaker, langCode, nameVariants);
};
